<template>
  <label @click.stop class="switch">
    <input type="checkbox" :checked="checked" @change="onChange">
    <span class="slider round">
      <div class="icon closed" :class="{hide:checked}">
        <slot name="icon.unchecked"></slot>
      </div>
      <div class="icon open" :class="{hide:!checked}">
        <slot name="icon.checked"></slot>
      </div>
    </span>
  </label>
</template>

<script>
import {computed} from "@vue/composition-api";
export default {
  name: "SwitchButton",
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {emit}){
    const checked = computed({
      get: () => props.value,
      set: (value) => {
        emit('input', value)
      }
    })

    function onChange(e){
      checked.value = e.target.checked
    }
    return {checked, onChange}
  }
}
</script>

<style scoped lang="scss">
.switch {
  position: relative;
  display: inline-block;
  width: 85px;
  height: 38px;

  input {
    position: absolute;
    z-index: -1;
    opacity: 0;
    width: 1rem;
    height: 1.25rem;

    &:checked + .slider:before {
      background-color: map-get($green, 'darken-1');
      transform: translateX(0);
    }
  }

  .slider {
    position: relative;
    background-color: #FFFFFF;
    box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    cursor: pointer;
    display: block;
    transition: .4s;
    width: 85px;
    height: 38px;

    // Circle
    &:before {
      position: absolute;
      left: 5px;
      bottom: 3px;
      content: "";
      background-color: map-get($material-light, 'dividers');
      transform: translateX(44px);
      transition: .4s;
      height: 32px;
      width: 32px;
    }

    &.round {
      border-radius: 34px;
    }

    &.round:before {
      border-radius: 50%;
    }
  }

  .icon {
    position: absolute;
    top: 8px;
    transition: .4s;
    width: 20px;

    svg {
      max-width: 100%;
      height: auto;
    }
  }

  .closed {
    left: 16px;
  }

  .open {
    right: 16px;
  }

  .hide {
    opacity: 0;
  }
}
</style>
